import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface HouseSelectProps {
  houses: Array<{ id: string; name: string }>;
  value: string;
  onValueChange: (value: string) => void;
}

export const HouseSelect = ({ houses, value, onValueChange }: HouseSelectProps) => {
  return (
    <div className="grid gap-2">
      <Label htmlFor="house" className="text-base">Casa</Label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="text-base">
          <SelectValue placeholder="Seleccionar casa" />
        </SelectTrigger>
        <SelectContent className="bg-white">
          {houses.map((house) => (
            <SelectItem key={house.id} value={house.id} className="text-base">
              {house.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};